import { useAuth } from "../../context/AuthContext";

export default function BillingTab() {
  const { organization } = useAuth();

  return (
    <div>
      <div className="settings-section">
        <h2>Current Plan</h2>
        <p className="section-desc">Manage your subscription and billing</p>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "1rem",
            background: "#f0f9ff",
            borderRadius: "8px",
            border: "1px solid #bae6fd",
          }}
        >
          <div>
            <div style={{ fontWeight: 600, textTransform: "capitalize" }}>
              {organization?.plan || "Free"} Plan
            </div>
            <div style={{ fontSize: "0.85rem", color: "#6b7280" }}>
              Basic features for getting started
            </div>
          </div>
          <button className="btn btn-primary" style={{ width: "auto" }}>
            Upgrade Plan
          </button>
        </div>
      </div>

      <div className="settings-section">
        <h2>Payment Method</h2>
        <p className="section-desc">
          Add a payment method to upgrade or enable paid tools
        </p>
        <p style={{ color: "#6b7280", padding: "2rem 0", textAlign: "center" }}>
          Payment integration coming soon.
        </p>
      </div>

      <div className="settings-section">
        <h2>Billing History</h2>
        <p className="section-desc">View past invoices and receipts</p>
        <p style={{ color: "#6b7280", padding: "2rem 0", textAlign: "center" }}>
          No billing history yet.
        </p>
      </div>
    </div>
  );
}
